import { render, staticRenderFns } from "./CollectionsEdit.vue?vue&type=template&id=0a4406e4&"
import script from "./CollectionsEdit.vue?vue&type=script&lang=ts&"
export * from "./CollectionsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
